import { APP_PRODUCT_TYPE } from 'appConstants';
import type { IGenericObject } from 'types';

export const objectToQueryString = (params: IGenericObject): string =>
  Object.keys(params)
    .map((key) => key + '=' + params[key])
    .join('&');

export const productTypeUrlPrefix = (productType, url, exclude: string[] = []) => {
  if (!productType || exclude.includes(productType) || productType === APP_PRODUCT_TYPE.FERTILISER)
    return url;
  return `/${productType}${url}`;
};

export const locationStartsWith = (url: string) => window.location.pathname.indexOf(url) === 0;
